import type { ClassificationReason } from '~/components/Clive/types';

interface RecommendationBase {
  classification_reasons: ClassificationReason[]; // deprecated
  classification_reason_extra: Record<string, unknown>;
  structured_explanation: ClassificationReason[];
}

interface RelatedClaimRecommendation extends RecommendationBase {
  claim_number: string;
  claim_internal_information: Record<string, unknown>;
}

export interface RelatedPolicyRecommendation extends RecommendationBase {
  policy_data: Record<string, unknown>;
  policy_number?: string;

  [key: string]: unknown;
}

export interface BundleClassification {
  category: string;
  classification_reasons: ClassificationReason[];
  classification_reason_extra: Record<string, unknown>;
}

export interface EmailClassificationTaskResponse {
  summary: string;
  related_claim_recommendation?: RelatedClaimRecommendation;
  related_policy_recommendation?: RelatedPolicyRecommendation;
  bundle_classification: BundleClassification[];
}

interface GeneralEmailAnalysisExtra {
  version: number;
  is_successful?: boolean;
  summary_including_attachments?: string;
  classification_response?: EmailClassificationTaskResponse;
}

const CommunicationAiAnalysisVersion = 1;

export { CommunicationAiAnalysisVersion };
export type { GeneralEmailAnalysisExtra };
